export default __webpack_public_path__ + "static/media/Tick.dda932b4.svg";